module.exports = __webpack_public_path__ + "img/fotr-social.3cc910ee.png";